import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_LOCALE, B2cLocale, LOCALE_KEY } from '@app/shared/language-selector/b2c-locale';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  @Input()
  localeOptions: B2cLocale[];

  selectedLocale: B2cLocale = DEFAULT_LOCALE;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    const currentLocale = localStorage.getItem(LOCALE_KEY) ?? this.getDefaultLocale();
    this.changeLocale(currentLocale);
  }

  changeLocale(newLocaleValue: string): void {
    this.localeOptions
      .filter(locale => locale.value === newLocaleValue)
      .map(locale => (this.selectedLocale = locale));

    localStorage.setItem(LOCALE_KEY, newLocaleValue);
    this.translateService.use(newLocaleValue);
  }

  private getDefaultLocale(): string {
    const browserLocale = this.translateService.getBrowserCultureLang();
    return this.localeOptions.map(locale => locale.value).includes(browserLocale)
      ? browserLocale
      : DEFAULT_LOCALE.value;
  }
}
